import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { 
  fetchPaletteFolders, fetchComponentsForPalette, fetchComponentsForPaletteFolder,
} from 'actions/palette';

import cx from 'classnames';
import _ from 'lodash';
import { Nav, Image } from 'react-bootstrap';

import InfiniteScroll from "components/InfiniteScroll";

import styles from './palette.module.scss';
import { PaletteComponentCard } from './paletteComponentCard';
import StoryboardContext from 'components/Storyboard/context';
import { ShortLoader } from 'components/ApplicationLoader';


export const WidgetPaletteFolders = ({ editorSession, defaultParent, defaultPaletteId, paletteId, type, paletteData, typeName }) => {
  const dispatch = useDispatch();
  const iconPaletteRef = React.useRef(null);
  const storyboardContext = React.useContext(StoryboardContext);
  const storyboardType = _.get(storyboardContext, 'type');
  const folders = useSelector(state => _.get(state, `palette.brandkit[${paletteId}].folders.items`, []));
  const defaultFolders = useSelector(state => _.get(state, `palette.default[${defaultPaletteId}].folders.items`, []));

  const fetched = useSelector(state => _.get(state, `palette.default[${paletteId}].folders.fetched`, false));
  const fetchedDefault = useSelector(state => _.get(state, `palette.default[${defaultPaletteId}].folders.fetched`, false));

  const components = useSelector(state => { return _.get(state, `palette.brandkit[${paletteId}].items`) || [] })
  const componentsFetched = useSelector(state => { return _.get(state, `palette.brandkit[${paletteId}].fetched`) || false });

  const workspace = useSelector((state) => _.get(state, "workspaces.workspace.item"));
  const brandkitEnabled = _.get(workspace, 'brandkitEnabled', false);
  const showDefault = _.get(paletteData, 'showDefault', false) || !brandkitEnabled;

  const loading = useSelector(state => { return _.get(state, `palette.brandkit[${paletteId}].loading`) || false });
  const defaultLoading = useSelector(state => { return _.get(state, `palette.default[${defaultPaletteId}].loading`) || false });

  const showOtherBrandkitFolder = components.length > 0;

  const showEmptyMessage = components.length == 0 && !showDefault && folders.length == 0;

  useEffect(() => {
    if (paletteId && !fetched) {
      dispatch(fetchPaletteFolders(paletteId, 'brandkit'));
      handleComponentsForPalette(0);
    }
  }, [paletteId]);

  useEffect(() => {
    if (defaultPaletteId && !fetchedDefault) {
      dispatch(fetchPaletteFolders(defaultPaletteId, 'default'));
      handleComponentsForPalette(0);
    }
  }, [defaultPaletteId]);

  const handleComponentsForPalette = (page) => {
    var request = {
      sort: 'order',
      order: 'ASC',
      widgetResponse: false
    }
    dispatch(fetchComponentsForPalette(paletteId, 'brandkit', request, page, 50));
  }

  const handleFolderSelect = (folder) => {
    const folderElement = document.getElementById(folder);
    if (folderElement) {
      folderElement.scrollIntoView({ behavior: 'smooth' });
    }
  }

  if(loading || defaultLoading) {
    return (
      <div className={styles.paletteLoaderContainer}>
      <ShortLoader className={styles.paletteLoaderContainer}/>
    </div>
    );
  }

  return (
    <>
    { (showEmptyMessage && componentsFetched) &&
      <BrandkitEmptyMessageCard/>
    }
    { !showEmptyMessage && 
      <div className={styles.iconManagement}>
        <div className={styles.iconFolders}>
          <Nav variant="pills" className={styles.iconManagementTab}>

          {brandkitEnabled && (folders.length>0 || showOtherBrandkitFolder) &&
            <>
              <div className={styles.headerTitle}>{`BRAND ${typeName}`}</div>
              {folders.map(folder => {
                return (
                  <Nav.Item key={folder.id} onClick={() => { handleFolderSelect(folder.id) }}>
                    <Nav.Link eventKey={folder.id}>{folder.name}</Nav.Link>
                  </Nav.Item>
                )
              })}

              {showOtherBrandkitFolder && 
                <Nav.Item key={`${paletteId}_otherFolder`} onClick={() => { handleFolderSelect(`${paletteId}_otherFolder`) }}>
                <Nav.Link eventKey={`${paletteId}_otherFolder`}>Other</Nav.Link>
              </Nav.Item>
              }
              <hr />
            </>
          }

          {showDefault && 
              <>
                <div className={styles.headerTitle}>CLEVERSTORY</div>
                {defaultFolders.map(folder => {
                  if ( storyboardType === 'SPATIAL' && typeName === 'ASSET GRIDS' && folder.name === 'Static Cards') {
                    return null;
                  }
                  return (
                    <Nav.Item key={folder.id} onClick={() => { handleFolderSelect(folder.id) }}>
                      <Nav.Link eventKey={folder.id}>{folder.name}</Nav.Link>
                    </Nav.Item>
                  )
                })}

                {!_.includes(['ASSET GRIDS'], typeName) && 
                  <Nav.Item key={`${paletteId}_defaultFolder`} onClick={() => { handleFolderSelect(`${paletteId}_defaultFolder`) }}>
                    <Nav.Link eventKey={`${paletteId}_defaultFolder`}>Default</Nav.Link>
                  </Nav.Item>
                }
            </>
          }
          </Nav>
        </div>

        <div className={styles.iconContent} ref={iconPaletteRef}>
          {brandkitEnabled && (folders.length>0 || showOtherBrandkitFolder) &&
            <>
              <div className={cx(styles.paletteTitle, styles.shapeTitle)}>
                <h3 className={styles.label}>{`BRAND ${typeName}`}</h3>
                <hr className={styles.labelHighliter} />
              </div>

              {folders.map(folder => {
                return (
                  <FolderPaletteComponentsView
                    key={folder.id}
                    editorSession={editorSession}
                    defaultParent={defaultParent}
                    paletteId={paletteId}
                    folder={folder}
                    type={'brandkit'}
                    typeName={typeName}
                  />
                )
              })}

              {showOtherBrandkitFolder &&
                <MultiwidgetPaletteComponentsView editorSession={editorSession}
                defaultParent={defaultParent}
                paletteId={paletteId}
                type={'brandkit'}  
                typeName={typeName}
                folderName={'Other'}
                folderId={`${paletteId}_otherFolder`}
                />
              }
              
              </>
          }

          {showDefault && 
            <>
              <div className={cx(styles.paletteTitle, styles.shapeTitle)}>
                <h3 className={styles.label}>CLEVERSTORY</h3>
                <hr className={styles.labelHighliter} />
              </div>
            
              {defaultFolders.map(folder => {
                if ( storyboardType === 'SPATIAL' && typeName === 'ASSET GRIDS' && folder.name === 'Static Cards') {
                  return null;
                }
                return (
                  <FolderPaletteComponentsView
                    key={folder.id}
                    editorSession={editorSession}
                    defaultParent={defaultParent}
                    paletteId={defaultPaletteId}
                    folder={folder}
                    type={'default'}
                    typeName={typeName}
                  />
                )
              })}

              {!_.includes(['ASSET GRIDS'], typeName) && 
                <MultiwidgetPaletteComponentsView editorSession={editorSession}
                defaultParent={defaultParent}
                paletteId={defaultPaletteId}
                type={'default'}  
                typeName={typeName}
                folderName={'Default'}
                folderId={`${paletteId}_defaultFolder`}
                />
              }
            </>
          }

        </div>
      </div>
    }
    </>
  )
}

export const FolderPaletteComponentsView = ({ editorSession, defaultParent, paletteId, folder, type }) => {
  const dispatch = useDispatch();

  const folderId = _.get(folder, 'id');
  const storyboardContext = React.useContext(StoryboardContext);
  const storyboardType = _.get(storyboardContext, 'type');
  const components = useSelector(state => _.get(state, `palette.${type}[${paletteId}].folders[${folder.id}].items`, []));
  const fetched = useSelector(state => _.get(state, `palette.${type}[${paletteId}].folders[${folder.id}].fetched`, false));
  const loading = useSelector(state => _.get(state, `palette.${type}[${paletteId}].folders[${folder.id}].loading`, false));
  const pagination = useSelector(state => _.get(state, `palette.${type}[${paletteId}].folders[${folder.id}].pagination`, {}));
  const hasMoreItems = _.get(pagination, "currentPage") < _.get(pagination, "totalPages") - 1;

  useEffect(() => {
    if (paletteId && folderId && !fetched) {
      handleFetchComponentsForFolder(0);
    }
  }, [paletteId, folderId]);

  const handleFetchComponentsForFolder = (page) => {
    var request = {
      sort: 'order',
      order: 'ASC',
      widgetResponse: false
    }
    dispatch(fetchComponentsForPaletteFolder(paletteId, folderId, type, request, page, 10));
  }

  const loadMore = () => {
    const nextPage = pagination.currentPage + 1;
    if (nextPage >= pagination.totalPages || loading) {
      return;
    }
    handleFetchComponentsForFolder(nextPage);
  }

  return (
    <div className={styles.commonContainer} id={folderId}>
      <div className={styles.header}>{folder.name}</div>
      <InfiniteScroll
        className={cx(styles.scrollable)}
        loading={loading}
        hasMore={hasMoreItems}
        loadMore={loadMore}
      >
        <div className={cx(styles.grid)}>
          {components.map((component, index) => {
            const widgets = _.get(component, 'content.widgets', []);
            if (!widgets || (storyboardType === 'SPATIAL' && component.type === 'INLINE_CARDS' && component.name === 'In-Line Card Document')) {
              return null;
            }

            const widget = widgets[0];

            return <PaletteComponentCard editorSession={editorSession} defaultParent={defaultParent} component={component}/>
          })}
        </div>
      </InfiniteScroll>
    </div>
  )
}

export const MultiwidgetPaletteComponentsView = ({ editorSession, defaultParent, paletteId, type, folderName, folderId, typeName }) => {
  const dispatch = useDispatch();

  const components = useSelector(state => { return _.get(state, `palette.[${type}][${paletteId}].items`) || [] })
  const loading = useSelector(state => { return _.get(state, `palette.[${type}][${paletteId}].loading`) || false })
  const fetched = useSelector(state => { return _.get(state, `palette.[${type}][${paletteId}].fetched`) || false })
  const pagination = useSelector(state => { return _.get(state, `palette.[${type}][${paletteId}].pagination`) || {} })
  const hasMoreItems = _.get(pagination, "currentPage") < _.get(pagination, "totalPages") - 1;


  useEffect(() => {
    if (paletteId && !fetched) {
      handleComponentsForPalette(0);
    }
  }, [paletteId]);

  const handleComponentsForPalette = (page) => {
    var request = {
      sort: 'order',
      order: 'ASC',
      widgetResponse: false
    }
    dispatch(fetchComponentsForPalette(paletteId, type, request, page, 50));
  }

  const loadMore = () => {
    const nextPage = pagination.currentPage + 1;
    if (nextPage >= pagination.totalPages) {
      return;
    }
    handleComponentsForPalette(nextPage);
  }

  if (components.length === 0) {
    return null;
  }

  return (
    <div className={styles.commonContainer} id={folderId}>
      <div className={styles.header}>{folderName}</div>
        <InfiniteScroll
          className={cx(styles.scrollable)}
          loading={loading}
          hasMore={hasMoreItems}
          loadMore={loadMore}
        >
          <div className={cx(styles.grid)}>
          {components.map((component, index) => {
            const widgets = _.get(component, 'content.widgets', []);
            if (!widgets) {
              return null;
            }

            return <PaletteComponentCard key={index} editorSession={editorSession} defaultParent={defaultParent} component={component} typeName={typeName} folderName={folderName}/>
          })}
          </div>
        
        </InfiniteScroll>
    </div>
  )
}

export const BrandkitEmptyMessageCard = () => {
  return(
    <div className={styles.brandkitEmptyMessageContainer}>
      <div>
        <Image src={'/images/brandkitEmptyMessageImg.png'} className={styles.emptyImage}/>
      </div>
      <div className={styles.title}>
        Brand Elements not available / not enabled
      </div>
      <div className={styles.description}>
        Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod.
      </div>
    </div>
  )
}